import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "timeout-modal",
    closeBtn: _ctx.allowClose
  }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
    footer: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "footer-btns" }, null, -1)
    ]))]),
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "error" }, " Please refresh and select your information again to save your changes. ", -1))
    ]),
    _: 1
  }, 8, ["closeBtn"]))
}